import { render, staticRenderFns } from "./WorkshopKitList.vue?vue&type=template&id=ac4dd8ae"
import script from "./WorkshopKitList.vue?vue&type=script&lang=ts"
export * from "./WorkshopKitList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports